import { render, staticRenderFns } from "./BuilderForm.vue?vue&type=template&id=f2511d56&scoped=true&"
import script from "./BuilderForm.vue?vue&type=script&lang=js&"
export * from "./BuilderForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2511d56",
  null
  
)

export default component.exports